export default {
    apiKey: "AIzaSyATJNJlbmiRt-dXbAtnfhlmg6ww2K6IAxA",
    authDomain: "prod-pewpew-cards.firebaseapp.com",
    projectId: "prod-pewpew-cards",
    storageBucket: "prod-pewpew-cards.firebasestorage.app",
    messagingSenderId: "593340628507",
    appId: "1:593340628507:web:05144b328b5663f54142be"
};